import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { IContestSpecialPeriod } from "@/components_v3/affiliate/contest/entities/cashback-offer/model/types";
import {
    formatContestSpecialPeriodLabel,
    getContestMonthDateBounds,
} from "@/components_v3/affiliate/contest/shared/config/contest-months";
import { parseContestPeriodRange } from "@/components_v3/affiliate/contest/shared/lib/parse-contest-period-range.lib";
import BaseCheckbox from "@/components-UI/BaseCheckbox.vue";
import BaseDateTimePicker from "@/components-UI/BaseDateTimePicker.vue";
import BaseQuestionMarkTooltip from "@/components-UI/BaseQuestionMarkTooltip.vue";
import SvgContestCalendar from "@/assets/icons/contest-calendar.svg";

interface Props {
    month: string;
    specialPeriodEnabled?: boolean;
    specialPeriod?: IContestSpecialPeriod | null;
    isEditing?: boolean;
    isOfferSelected?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestOfferSpecialPeriodRow',
  props: {
    month: null,
    specialPeriodEnabled: { type: Boolean, default: false },
    specialPeriod: { default: null },
    isEditing: { type: Boolean, default: false },
    isOfferSelected: { type: Boolean, default: true }
  },
  emits: ["update:special-period-enabled", "update:special-period"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:special-period-enabled', enabled: boolean): void;
    (e: 'update:special-period', period: IContestSpecialPeriod | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { month: string, specialPeriodEnabled: boolean, specialPeriod: IContestSpecialPeriod | null, isEditing: boolean, isOfferSelected: boolean }

const SPECIAL_PERIOD_TOOLTIP = 'Данное свойство позволяет проставить отдельный индивидуальный бонус за лид на период, выбранный в рамках месяца. Указанные бонусы будут приоритетными над заданными в столбце "Бонус за лид".';





const isCheckboxDisabled = computed(() => !props.isEditing || !props.isOfferSelected);

const monthDateBounds = computed(() => getContestMonthDateBounds(props.month));

const periodRangeValue = computed(() => {
    if (!props.specialPeriod) {
        return null;
    }

    return {
        start: props.specialPeriod.from,
        end: props.specialPeriod.to,
    };
});

const periodLabel = computed(() => {
    if (!props.specialPeriod) {
        return '';
    }

    return formatContestSpecialPeriodLabel(props.specialPeriod.from, props.specialPeriod.to);
});

function onPeriodChange(value: unknown): void {
    emit('update:special-period', parseContestPeriodRange(value));
}

return { __sfc: true,SPECIAL_PERIOD_TOOLTIP, props, emit, isCheckboxDisabled, monthDateBounds, periodRangeValue, periodLabel, onPeriodChange, BaseCheckbox, BaseDateTimePicker, BaseQuestionMarkTooltip, SvgContestCalendar }
}

})